import { isMobile, isIos } from './helper'

let _slot;

const interstitial = () => {
    if (!isMobile()) return;
    let slot = {
        cont: 'gpt-transition'
    };
    if (isIos()) {
        slot.adUnit = "/6870/ynet_mobile/ynet_mobileweb_transitions/ynet_mobileweb_transitions_general/ynet_mobileweb_transitions_general_iphone_main_ip";
        slot.size = [1, 1];
    }
    else {
        slot.adUnit = "/6870/ynet_mobile/ynet_mobileweb_transitions/ynet_mobileweb_transitions_general/ynet_mobileweb_transitions_general_android_main_ip";
        slot.size = [1, 2];
    }
    if (_slot) window.googletag.destroySlots([_slot]);
    window.googletag.cmd.push(function () {
        _slot = window.googletag.defineSlot(slot.adUnit, slot.size, slot.cont);
        _slot.addService(window.googletag.pubads());
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
        window.googletag.display(slot.cont);
    });
}

const adUnit = isMobile() ? `
 /6870/ynet_mobile/Ynet_MobileWeb_${isIos() ? 'Iphone' : 'Android'}_preroll_channel_relationship
`:
`/6870/ynet/video_desktop/relationship`

const custParams = `
VideoPosition=Preroll
&dcPath=550.Auto
&autoplay=false
&VideoPosition_autoplay=false
&view=0
`
const prerollTag = `https://pubads.g.doubleclick.net/gampad/ads?
sz=640x480|640x360
&iu=${adUnit}
&impl=s
&gdfp_req=1
&env=vp
&output=vast
&unviewed_position_start=1
&url=[referrer_url]
&description_url=${encodeURIComponent(window.location.href)}
&correlator=[timestamp]
&cust_params=@cust_params
`.replace(/@cust_params/,
    encodeURIComponent(custParams.replace(/\r?\n|\r|\s/g, '')))
    .replace(/\r?\n|\r|\s/g, '')

export {
    interstitial,
    prerollTag
}


// WEBPACK FOOTER //
// ./src/ads.js


// WEBPACK FOOTER //
// ./src/static/ads.js